/* ============================================================
   AURORE — About Page JavaScript
   File: assets/aurore-about.js

   HOW TO ADD:
   1. Go to Online Store → Themes → Edit Code
   2. Open assets/ → Add new asset → aurore-about.js
   3. Paste this file
   4. In layout/theme.liquid, before </body>, add:
      <script src="{{ 'aurore-about.js' | asset_url }}" defer></script>
   ============================================================ */
(function () {
  'use strict';

  /* ---- Gift Guide Tabs ---- */
  function initGiftTabs() {
    var tabs = document.querySelectorAll('.au-gift-tab');
    var panels = document.querySelectorAll('.au-gift-panel');
    if (!tabs.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var targetId = 'au-tab-' + tab.dataset.tab;

        tabs.forEach(function (t) {
          t.classList.remove('active');
          t.setAttribute('aria-selected', 'false');
        });
        panels.forEach(function (p) {
          p.classList.remove('active');
        });

        tab.classList.add('active');
        tab.setAttribute('aria-selected', 'true');
        var target = document.getElementById(targetId);
        if (target) target.classList.add('active');
      });

      /* Keyboard navigation */
      tab.addEventListener('keydown', function (e) {
        var allTabs = Array.from(tabs);
        var currentIndex = allTabs.indexOf(tab);
        var nextIndex;

        if (e.key === 'ArrowRight') {
          nextIndex = (currentIndex + 1) % allTabs.length;
          allTabs[nextIndex].focus();
          allTabs[nextIndex].click();
        } else if (e.key === 'ArrowLeft') {
          nextIndex = (currentIndex - 1 + allTabs.length) % allTabs.length;
          allTabs[nextIndex].focus();
          allTabs[nextIndex].click();
        } else if (e.key === 'Home') {
          allTabs[0].focus();
          allTabs[0].click();
        } else if (e.key === 'End') {
          allTabs[allTabs.length - 1].focus();
          allTabs[allTabs.length - 1].click();
        }
      });
    });
  }

  /* ---- Scroll-in animation (IntersectionObserver) ---- */
  function initScrollAnimations() {
    if (!('IntersectionObserver' in window)) return;

    var style = document.createElement('style');
    style.textContent =
      '.au-fade-up { opacity: 0; transform: translateY(24px); transition: opacity 0.55s ease, transform 0.55s ease; }' +
      '.au-fade-up.au-visible { opacity: 1; transform: translateY(0); }';
    document.head.appendChild(style);

    var targets = document.querySelectorAll(
      '.au-pillar-item, .au-care-card, .au-budget-card, .au-timeline-step, .au-gift-mini'
    );
    targets.forEach(function (el) {
      el.classList.add('au-fade-up');
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('au-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ---- Init ---- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initGiftTabs();
      initScrollAnimations();
    });
  } else {
    initGiftTabs();
    initScrollAnimations();
  }
})();